import { render } from "./SmsLookup.vue?vue&type=template&id=c97d340e"
import script from "./SmsLookup.vue?vue&type=script&lang=js"
export * from "./SmsLookup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__